import useClientStore from "../../stores/ClientStore";
import Clients from "../clients/Clients";
import ClientDetail from "../clients/ClientDetail";

const Home = props => {

    const {selectedClient, setSelectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient, setSelectedClient: state.selectClient}))

    return(
        <>

            {!selectedClient && <Clients />}
            {selectedClient && <ClientDetail />}

        </>
    )
}

export default Home